import { render, staticRenderFns } from "./basecost-setting-list.vue?vue&type=template&id=50133299&"
import script from "./basecost-setting-list.vue?vue&type=script&lang=ts&"
export * from "./basecost-setting-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports